export const countryCodeNumber = [
  { id: 'Singapore', name: '(+65)' },
  { id: 'Malaysia', name: '(+60)' },
];
